import { useContext, useEffect, useState } from "react";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { Provider } from "react-redux";
import Tiles from "../../components/bluetile";
import { FleatoBaseProps } from "../_app";
import store from "../../store/slices/index.slice";
import { GrPowerReset } from "react-icons/gr";
import { TilesContext } from "../../contexts/TilesContext";
import QuantitySelector from "../../components/bluetile/quantity-selector/quantity-selector";
import { WizardProgressBar, WizardProgressText } from "../../styles/checkout-page-style";
import { UserContext } from "../../contexts/UserContext";
import html2canvas from "html2canvas";
import LoginModalWrapper from "../../components/login-modal/login-modal-wrapper";
import Modal from 'react-modal';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Image from "next/image";
import { saveAs } from 'file-saver';
import tileImage from '../../public/images/assets/tile-image.png';
import tShirtImage from '../../public/images/assets/tshirt.png';
import mousePadImage from '../../public/images/assets/mouse-pad.png';
import coffeeMugImage from '../../public/images/assets/coffee-mug.png';
import iPhoneImage from '../../public/images/assets/iphone-case.png';
import cryptoLoader from "../../public/lottie/14117-crypto-loader.json";
import Lottie from "react-lottie";

import { Product, Variation, VariationOption } from "../../models/product";
import { tagFinalizeBlueTile } from "../../lib/events";

const BuildPage: NextPage<FleatoBaseProps> = ({ }) => {
  const router = useRouter();
  const { background } = router.query;
  const { resetTiles, tiles, setTiles, exists, allowance, tokenId, name, tileWords, setTileWords, templateProduct, mint } = useContext(TilesContext);
  {
    /* <iframe src={`http://localhost:3000/bluetile/build`} width="100%" height="90%" allowFullScreen></iframe> */
  }
  const [activeTab, setActiveTab] = useState('createTile');
  const [tilesImage, setTilesImage] = useState('');
  const [tileWidth, setTileWitdh] = useState(0);
  const { user, dbUser } = useContext(UserContext);
  const [showWalletBtn, setShowWalletBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedTileType, setSelectedTileType] = useState('words');
  const [isReset, setIsReset] = useState(false);
  const [merchandise, setMerchandise] = useState<Variation>();
  const [snapImage, setSnapImage] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [pickSize, setPickSize] = useState("");
  const [merchandiseOption, setSelectedVariationOption] = useState<VariationOption>();  

  useEffect(() => {
    if (merchandise && pickSize && selectedColor)
      setSelectedVariationOption(merchandise?.options?.find(o => o.size === pickSize && o.colorCode == selectedColor));
    else if (merchandise && pickSize) {
      setSelectedVariationOption(merchandise?.options?.find(o => o.size === pickSize));
      setSelectedColor(merchandise?.options?.find(o => o.size === pickSize)?.colorCode);
    } else if (merchandise && selectedColor) {
      setSelectedVariationOption(merchandise?.options?.find(o => o.colorCode === selectedColor));
      setPickSize(merchandise?.options?.find(o => o.size === pickSize)?.size);
    }
    else if (merchandise && merchandise.options?.length) {
      setSelectedVariationOption(merchandise?.options[0]);
      setSelectedColor(merchandise?.options[0]?.colorCode);
      setPickSize(merchandise?.options[0]?.size);
    } else {
      setSelectedVariationOption(null);
      setSelectedColor(null);
      setPickSize(null);
    }
  }, [merchandise, pickSize, selectedColor])

  useEffect(() => {
    if (pickSize && !merchandise?.options?.find(o => o.size == pickSize))
      setPickSize(null);
    if (selectedColor && !merchandise?.options?.find(o => o.colorCode == selectedColor))
      setSelectedColor(null);

    if (merchandise && !templateProduct?.variations?.find(v => v.sku === merchandise.sku)) {
      setMerchandise(null);
      setSelectedVariationOption(null);
      setSelectedColor(null);
      setPickSize(null);
    }
  }, [templateProduct, merchandise, pickSize, selectedColor]);

  const merchOptions = [
    { type: 't-shirt', image: tShirtImage.src, price: 30 },
    { type: 'mouse-pad', image: mousePadImage.src, price: 20 },
    { type: 'iphone-case', image: iPhoneImage.src, price: 25 },
    { type: 'coffee-mug', image: coffeeMugImage.src, price: 15 },
    { type: 'only-tile', image: tileImage.src, price: 200 },
  ]
  useEffect(() => {
    if (dbUser?.wallets?.length) {
      setShowWalletBtn(false);
    }
    else {
      setShowWalletBtn(true);

    }
  }, [dbUser])

  const convertTiles = async () => {
    html2canvas(document.getElementById(selectedTileType == 'shapes' ? 'shape-tiles' : 'word-tiles')).then(function (canvas) {
      // Below code is to check the canvas 
      // let tileCanvasImage = new Image();
      // tileCanvasImage.src = canvas.toDataURL();
      // document.appendChild(tileCanvasImage);
      setTilesImage(canvas.toDataURL());
    });
  }

  const [validation, setValidationError] = useState<string>();
  const handleFinalize = async () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
    setLoading(true);
    if (selectedTileType == 'shapes') {
      // const taken = await exists();
      // const lives = await allowance();
      // tagFinalizeBlueTile(name, !taken[0] && !taken[1]);
      let error = !name.trim().length ? "Missing the name" : "";
      // const error = taken[0] && taken[1] ? "Oops, both the pattern and the name is taken" :
      //   taken[0] ? "OOps, that pattern is taken" :
      //     taken[1] ? "Oops, that name is taken" :
      setValidationError(error);
      if (error?.length > 0) {
        SwalAlert.fire({
          title: <h3>{error}</h3>,
          html: <p>{!name.trim().length ? "Please choose a name for your Blue Tile Art" : "Please continue building."}</p>,
          confirmButtonText: "Ok",
          confirmButtonColor: "#1478DD"
        });
        setLoading(false);
        return;
      } if (!!!merchandise) {
        SwalAlert.fire({
          title: <h3>Error</h3>,
          html: <p>{"Please choose a merchandise for your Blue Tile Art"}</p>,
          confirmButtonText: "Ok",
          confirmButtonColor: "#1478DD"
        });
        setLoading(false);
        return;
      }
      // else if (lives == 0) {
      //   SwalAlert.fire({
      //     title: <h3>Oops, you already used up your allowance!</h3>,
      //     html: <p>You will earn additional allowance as you engage with the blue tile project. We will keep you posted.</p>,
      //     confirmButtonText: "Ok",
      //     confirmButtonColor: "#1478DD"
      //   });
      //   setLoading(false);
      //   return;
      // }
      else {
        setLoading(false);
        handleActiveTab('details');
      }
    } else {
      if (tileWords?.length == 0) {
        SwalAlert.fire({
          title: <h3>{'OOPS!'}</h3>,
          html: <p>{"Please continue building."}</p>,
          confirmButtonText: "Ok",
          confirmButtonColor: "#1478DD"
        });
        setLoading(false);
        return;
      } else if (!!!merchandise) {
        SwalAlert.fire({
          title: <h3>Error</h3>,
          html: <p>{"Please choose a merchandise for your Blue Tile Art"}</p>,
          confirmButtonText: "Ok",
          confirmButtonColor: "#1478DD"
        });
        setLoading(false);
        return;
      }
      setSnapImage(true);
      setTimeout(() => {handleActiveTab('details'); setLoading(false);}, 1000);
      
    }

  }

  const handleActiveTab = async (activeTab: string) => {
    if (activeTab == 'details') {
      await convertTiles();
      setSnapImage(false);
    }
    if ((activeTab == 'listed' && !user?.uid) || (activeTab == 'details' && !user?.uid)) {
      alertLogin();
    }
    else {
      setActiveTab(activeTab);
    }
  }

  const closeModal = () => {
    setActiveTab('details');
  };
  const SwalAlert = withReactContent(Swal);

  const alertLogin = () => {
    SwalAlert.fire({
      title: <p>Almost there, Please Login</p>,
      showCancelButton: true,
      confirmButtonText: "Login",
      confirmButtonColor: "#1478DD"
    }).then(async (alert) => {
      if (alert.isConfirmed) {
        setActiveTab('showLogin');
      }
    });
  }
  const progressWidth = {
    createTile: { width: "0%", background: "#1478DD", height: 5 },
    details: { width: "100%", background: "#1478DD", height: 5 },
    listed: { width: "100%", background: "#1478DD", height: 5 },
  };
  return (
    <Provider store={store}>
      <div
        className="container-fluid p-0 mb-5"
        style={{
          flex: 1,
          justifyContent: "center",
          backgroundColor: `#${background}`,
        }}
      >
        <div className="seller-profile container py-5 mx-auto my-md-5 my-lg-4">
          <div className="col-8 mx-auto mb-5">
            <div className="wizardContainer ">
              <WizardProgressBar>
                <div className="progress edit-seller-progress  col-12">
                  <div className="progress-bar" role="progressbar"
                    style={activeTab === 'createTile' ? progressWidth.createTile : activeTab === 'details' || activeTab === 'showLogin' ? progressWidth.details : progressWidth.listed} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}
                  >
                  </div>
                </div>
                <div className="edit-progressBar progressBar " style={{ position: "relative", zIndex: 1 }}>
                  <div id="checked"></div>
                  <div id={activeTab !== 'createTile' ? "checked" : "not-checked"}></div>
                  {/* <div id={activeTab !== 'details' && activeTab !== 'createTile' && activeTab !== 'showLogin' ? "checked" : "not-checked"}></div> */}
                </div>
                <div className="edit-progressText progressText d-flex justify-content-between">
                  <p style={WizardProgressText} className="cursor-pointer underLined" onClick={() => handleActiveTab('createTile')}>Create Tile</p>
                  <p style={WizardProgressText} className="cursor-pointer underLined">Details</p>
                  {/* <p style={WizardProgressText} className="cursor-pointer underLined">Checkout</p> */}
                </div>
              </WizardProgressBar>
            </div>
          </div>
          {activeTab == 'createTile' && <>
          {loading ? <><Lottie height={200} width={200} options={{ loop: true, autoplay: true, animationData: cryptoLoader, }} /></> : 
          <div className="">
            <Tiles
              tiles={tiles}
              setTiles={setTiles}
              isReset={isReset}
              tileWords={tileWords}
              setTileWords={setTileWords}
              selectedTileType={selectedTileType}
              setSelectedTileType={setSelectedTileType}
              merchOptions={templateProduct?.variations ?? []}
              merchandise={merchandise}
              setMerchandise={setMerchandise}
              snapImage={snapImage}
              validation={validation}
              setValidationError={setValidationError}
              handleFinalize={() => handleFinalize()}
            />
            <div className="col-10 col-md-8 col-lg-4 d-flex flex-column flex-md-row align-items-center justify-content-md-between mx-auto mt-5">

              <button
                className="mb-2 mb-md-0 mx-3 btn btn-primary bg-white text-black d-flex align-items-center justify-content-center py-3 px-3  w-100"
                onClick={() => resetTiles(true)}
              >
                {" "}
                <GrPowerReset />
                &nbsp; Reset
              </button>
              {loading ?
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only"></span>
                </div>
                :
                <button
                  className="mb-2 mb-md-0 mx-3 btn btn-primary px-2 py-3  w-100"
                  onClick={() => handleFinalize()}
                >
                  Next
                </button>
              }
            </div>
          </div>
          }
          </>}

          {activeTab == 'details' && (
            <>
              <QuantitySelector
                handleActiveTab={handleActiveTab}
                tilesImage={tilesImage}
                resetTiles={resetTiles}
                tiles={tiles}
                merchImage={selectedTileType == 'words' ? merchandiseOption?.image : null}
                selectedTileType={selectedTileType}
                merchandise={merchandise}
                tileWords={tileWords}
                pickSize={pickSize}
                product={templateProduct}
                setPickSize={setPickSize}
                setSelectedColor={setSelectedColor}
                selectedColor={selectedColor}
                setTilesImage={setTilesImage}
                merchandiseOption={merchandiseOption}
                mint={mint}
              />
            </>
          )}
          {activeTab == 'listed' &&
            <>
              <div className=" text-center">
                <h1 className="fw-normal mb-5">Congratulations your tile has been reserved!</h1>
                {/* <p>Your Digital Collectible (NFT) is now being minted, we will notify you via email when it is ready for you to share with the world!</p> */}
                <div>
                  <Image src={tilesImage} height={400} width={400} />
                </div>
                <a className="fw-normal mb-5 text-blue cursor-pointer" onClick={() => saveAs(tilesImage, `${name}.png`)}>Download</a>

                <div className="btn-container mt-3">
                  {/* {showWalletBtn &&
                    <>
                      <button className="btn btn-primary me-md-2 p-5 py-2" onClick={() => router.push("/my-wallet")}>Create Fleato Wallet</button>
                      <button className="btn btn-primary me-md-2 p-5 py-2 bg-white text-black border-primary" onClick={() => setShowWalletBtn(false)}>{`I'll do Later`}</button>
                    </>
                  } */}
                  <button className="btn btn-primary me-md-2 p-5 py-2" onClick={() => router.push(`/bluetile/gallery/${dbUser?.handle}`)}>View My Gallery</button>
                </div>
              </div>
            </>
          }
          <Modal isOpen={activeTab == 'showLogin'} className="loginModal">
            <LoginModalWrapper closeModal={closeModal} setIsSigningUp={() => { }} />
          </Modal>

        </div>
      </div>
    </Provider>
  );
};
export default BuildPage;
